import { createElementBlock as r, openBlock as s, normalizeClass as i } from "vue";
import { themeProp as o } from "../../composables/useTheme.js";
const d = /* @__PURE__ */ Object.assign({
  name: "DsDivider"
}, {
  __name: "divider",
  props: {
    ...o
  },
  setup(t) {
    return (e, a) => (s(), r("hr", {
      class: i(["ds-divider", `ds-divider--${e.theme}`])
    }, null, 2));
  }
});
export {
  d as default
};
